/**
 * @generated SignedSource<<d236e4a2d1c14062ba1adea74ba2d0b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type financingLeadLostDialogQuery$variables = {};
export type financingLeadLostDialogQuery$data = {
  readonly lead_stages_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly label: string | null;
        readonly label_en: string | null;
      };
    }>;
  };
};
export type financingLeadLostDialogQuery = {
  response: financingLeadLostDialogQuery$data;
  variables: financingLeadLostDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "where",
        "value": {
          "_and": [
            {
              "pipeline": {
                "name": {
                  "_eq": "financing"
                }
              }
            },
            {
              "status": {
                "_eq": "lost"
              }
            }
          ]
        }
      }
    ],
    "concreteType": "lead_stagesConnection",
    "kind": "LinkedField",
    "name": "lead_stages_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "lead_stagesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "lead_stages",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label_en",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "lead_stages_connection(where:{\"_and\":[{\"pipeline\":{\"name\":{\"_eq\":\"financing\"}}},{\"status\":{\"_eq\":\"lost\"}}]})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "financingLeadLostDialogQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "financingLeadLostDialogQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "dfe9408b157a3622372eca0d4da4dede",
    "id": null,
    "metadata": {},
    "name": "financingLeadLostDialogQuery",
    "operationKind": "query",
    "text": "query financingLeadLostDialogQuery {\n  lead_stages_connection(where: {_and: [{pipeline: {name: {_eq: \"financing\"}}}, {status: {_eq: lost}}]}) {\n    edges {\n      node {\n        id\n        label\n        label_en\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e9d2461257b36d3e44c358356a027dd";

export default node;
